import { Card, Typography, Table, Badge, Tag, Space } from "antd"
import {
  PlayCircleOutlined
} from "@ant-design/icons"

const { Text, Paragraph } = Typography

const ExecutionFeed = () => {

  // Auto-Execution Feed Data
  const executionFeedData = [
    {
      key: "1",
      task: "Vendor Payment Approval",
      system: "ERP",
      reason: "Invoice threshold exceeded $50K",
      timeToExecution: "2m 15s",
      assignedTo: "Finance Team",
      status: "completed",
      timestamp: "14:32:15",
    },
    {
      key: "2",
      task: "Risk Mitigation Plan",
      system: "Asana",
      reason: "Supplier reliability score dropped below 85%",
      timeToExecution: "5m 42s",
      assignedTo: "Operations",
      status: "in-progress",
      timestamp: "14:28:33",
    },
    {
      key: "3",
      task: "Opportunity Alert",
      system: "Slack",
      reason: "Market trend detected: 15% price drop in raw materials",
      timeToExecution: "1m 08s",
      assignedTo: "Procurement",
      status: "pending",
      timestamp: "14:25:47",
    },
  ]

  return (
    <Card
        title={
          <Space>
            <PlayCircleOutlined style={{ color: "#52c41a" }} />
            <span>Auto-Execution Feed (Unique)</span>
            <Badge count="Live" style={{ backgroundColor: "#52c41a" }} />
          </Space>
        }
        style={{ marginBottom: "24px" }}
      >
        <Paragraph>
          Live feed of tasks auto-pushed into systems (Asana, Jira, ERP, Slack) showing the origin story of ops.
        </Paragraph>
        <Table
          dataSource={executionFeedData}
          pagination={false}
          size="small"
          columns={[
            {
              title: "Task",
              dataIndex: "task",
              key: "task",
              render: (text) => <Text strong>{text}</Text>,
            },
            {
              title: "System",
              dataIndex: "system",
              key: "system",
              render: (text) => <Tag color="blue">{text}</Tag>,
            },
            {
              title: "Why Pushed",
              dataIndex: "reason",
              key: "reason",
            },
            {
              title: "Time to Execution",
              dataIndex: "timeToExecution",
              key: "timeToExecution",
              render: (text) => <Text code>{text}</Text>,
            },
            {
              title: "Assigned To",
              dataIndex: "assignedTo",
              key: "assignedTo",
              render: (text) => <Tag color="purple">{text}</Tag>,
            },
            {
              title: "Status",
              dataIndex: "status",
              key: "status",
              render: (status) => {
                const colors = { completed: "success", "in-progress": "processing", pending: "warning" }
                return <Badge status={colors[status]} text={status} />
              },
            },
          ]}
        />
      </Card>
  )
}

export default ExecutionFeed